 
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Step } from 'react-joyride';
import { DASHBOARD_TABS, type DashboardTab } from '../types/dashboard';

export interface TutorialStep extends Step {
  id: string;
  section: string;
  tabToActivate?: DashboardTab;
}

export const tutorialSteps: TutorialStep[] = [
  // Welcome
  {
    id: 'welcome',
    section: 'welcome',
    target: 'body',
    placement: 'center',
    content: `Welcome to Smartphone Inc.!

You're about to build your own smartphone empire.

This tutorial will guide you through the essential game mechanics.`,
    disableBeacon: true,
    spotlightClicks: false,
  },

  // Headquarters Tab
  {
    id: 'headquarters-tab',
    section: 'headquarters',
    target: '[data-tutorial="headquarters-tab"]',
    placement: 'bottom',
    content: 'This is the Headquarters tab - your main dashboard where you can see company overview and key metrics.',
    disableBeacon: true,
    spotlightClicks: false,
    tabToActivate: DASHBOARD_TABS.HEADQUARTERS
  },
  {
    id: 'company-info',
    section: 'headquarters',
    target: '[data-tutorial="company-info"]',
    placement: 'right',
    content: 'Here you can see your company name and game controls. Use the speed buttons to control game speed or pause.',
    spotlightClicks: false,
  },
  {
    id: 'cash-display',
    section: 'headquarters',
    target: '[data-tutorial="cash-display"]',
    placement: 'left',
    content: 'Your current cash balance is shown here. Keep an eye on it - running out of money means bankruptcy!',
    spotlightClicks: false,
  },

  // Products Tab
  {
    id: 'products-tab',
    section: 'products',
    target: '[data-tutorial="products-tab"]',
    placement: 'bottom',
    content: 'The Products tab is where you manage your smartphone lineup.',
    spotlightClicks: true,
    tabToActivate: DASHBOARD_TABS.PRODUCTS
  },
  {
    id: 'product-portfolio',
    section: 'products',
    target: '[data-tutorial="product-portfolio"]',
    placement: 'right',
    content: 'Here you can see all your products in various stages: development, production, and market.',
    spotlightClicks: false,
  },
  {
    id: 'new-product-button',
    section: 'products',
    target: '[data-tutorial="new-product-button"]',
    placement: 'bottom',
    content: 'Click here to design a new smartphone. You\'ll enter the Design Studio to create your product.',
    spotlightClicks: false,
  },

  // Operations Tab
  {
    id: 'operations-tab',
    section: 'operations',
    target: '[data-tutorial="operations-tab"]',
    placement: 'bottom',
    content: 'The Operations tab manages your workforce and facilities.',
    spotlightClicks: true,
    tabToActivate: DASHBOARD_TABS.OPERATIONS
  },
  {
    id: 'employees-section',
    section: 'operations',
    target: '[data-tutorial="employees-section"]',
    placement: 'right',
    content: 'Manage your employees here. You need engineers for development, designers for design, testers for QA, and workers for production.',
    spotlightClicks: false,
  },
  {
    id: 'buildings-section',
    section: 'operations',
    target: '[data-tutorial="buildings-section"]',
    placement: 'right',
    content: 'Purchase and upgrade buildings to increase your company capacity and capabilities.',
    spotlightClicks: false,
  },

  // Research Tab
  {
    id: 'research-tab',
    section: 'research',
    target: '[data-tutorial="research-tab"]',
    placement: 'bottom',
    content: 'The Research tab lets you unlock new technologies and components.',
    spotlightClicks: true,
    tabToActivate: DASHBOARD_TABS.RESEARCH
  },
  // {
  //   id: 'research-tree',
  //   section: 'research',
  //   target: '[data-tutorial="research-tree"]',
  //   placement: 'top',
  //   content: 'Research new technologies to unlock better components and features for your products. Research points are earned over time.',
  //   spotlightClicks: false,
  // },

  // Marketing Tab
  {
    id: 'marketing-tab',
    section: 'marketing',
    target: '[data-tutorial="marketing-tab"]',
    placement: 'bottom',
    content: 'The Marketing tab shows market insights and competitor analysis.',
    spotlightClicks: true,
    tabToActivate: DASHBOARD_TABS.MARKETING
  },
  // {
  //   id: 'market-insights',
  //   section: 'marketing',
  //   target: '[data-tutorial="market-insights"]',
  //   placement: 'top',
  //   content: 'View market trends, competitor products, and market share distribution here.',
  //   spotlightClicks: false,
  // },

  // Finance Tab
  {
    id: 'finance-tab',
    section: 'finance',
    target: '[data-tutorial="finance-tab"]',
    placement: 'bottom',
    content: 'The Finance tab provides detailed financial reports and analytics.',
    spotlightClicks: true,
    tabToActivate: DASHBOARD_TABS.FINANCE
  },
  // {
  //   id: 'financial-reports',
  //   section: 'finance',
  //   target: '[data-tutorial="financial-reports"]',
  //   placement: 'top',
  //   content: 'Track revenue, expenses, profit margins, and cash flow over time.',
  //   spotlightClicks: false,
  // },

  // Calendar Tab
  {
    id: 'calendar-tab',
    section: 'calendar',
    target: '[data-tutorial="calendar-tab"]',
    placement: 'bottom',
    content: 'The Calendar tab shows upcoming events and important dates.',
    spotlightClicks: true,
    tabToActivate: DASHBOARD_TABS.CALENDAR
  },
  // {
  //   id: 'events-log',
  //   section: 'calendar',
  //   target: '[data-tutorial="events-log"]',
  //   placement: 'top',
  //   content: 'Keep track of game events, product launches, and market changes here.',
  //   spotlightClicks: false,
  // },

  // Company Tab
  {
    id: 'company-tab',
    section: 'company',
    target: '[data-tutorial="company-tab"]',
    placement: 'bottom',
    content: 'The Company tab shows your company profile and reputation.',
    spotlightClicks: true,
    tabToActivate: DASHBOARD_TABS.COMPANY
  },
  // {
  //   id: 'company-profile',
  //   section: 'company',
  //   target: '[data-tutorial="company-profile"]',
  //   placement: 'top',
  //   content: 'View your company\'s reputation, achievements, and overall performance metrics.',
  //   spotlightClicks: false,
  // },
//   {
//     id: 'tutorial-complete',
//     section: 'complete',
//     target: 'body',
//     placement: 'center',
//     content: `🎉 Tutorial Complete!

// You've learned the basics of Smartphone Inc.

// Note: This game is still in early development.

// More features and content are coming soon. Enjoy building your smartphone empire!`,
//     disableBeacon: true,
//     spotlightClicks: false,
//   },
];

export const getTutorialStepById = (id: string): TutorialStep | undefined => {
  return tutorialSteps.find(step => step.id === id);
};

export const getTutorialStepsBySection = (section: string): TutorialStep[] => {
  return tutorialSteps.filter(step => step.section === section);
};